import React from 'react';
import { connect } from 'react-redux';
// import actions from 'actions/node/creators';
import lodashGet from 'lodash.get';
// import antMessage from 'antd/lib/message';
import notification from 'antd/lib/notification';

class SnackbarSimple extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { snackbar } = nextProps;
    const { message, messageType, containerClassName } = snackbar;
    if (!message) return;

    const getContainer = () => {
      const notificationContainer = document.getElementsByClassName(
        containerClassName || 'snackbar-notification-container',
      )[0];

      if (notificationContainer) {
        return notificationContainer;
      }

      // default case
      return document.body;
    };

    let duration = lodashGet(snackbar, 'duration', 4.5);

    notification.config({
      duration,
    });

    if (messageType === 'success' || messageType === true)
      notification.success({
        getContainer,
        message,
        // description: message,
      });
    else if (messageType === 'error') {
      notification.destroy();
      notification.error({
        message,
        getContainer,
        // description: message,
      });
    } else if (messageType === 'warning')
      notification.warning({
        getContainer,
        message, // t3('warning'),
        // description: message,
      });
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  return { snackbar: lodashGet(state, 'ui.snackbar') };
}

export default connect(mapStateToProps)(SnackbarSimple);
